const MatchCase = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M80-200v-80h800v80H80Zm120-160 140-400h80l140 400h-76l-32-92H308l-32 92h-76Zm138-152h124l-60-172h-4l-60 172Zm362 152v-248q0-35-19.5-58.5T628-690q-24 0-42 13t-30 35l-60-26q18-34 51.5-53t71.5-19q66 0 103.5 43T760-592v232h-60Zm-60-76v-56q0-27-17-43.5T584-552q-23 0-39.5 13.5T528-508l-56-28q14-32 44-50t68-18q57 0 91.5 34t34.5 86v124h-60Z" />
        </svg>
    )
}

export default MatchCase;

